import React, { useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { useGameQuery } from "../../hooks/useGameQuery";
import GameLobby from "./GameLobby";
import { PlayerContextProvider } from "../CurrentPlayerContext";
import { UserContext } from "../UserContext";
import Modal from "../modal";
import Button from "../button";
import joinGameGIF from "../../assets/images/join-game.gif";
import LoadingIndicator from "../LoadingIndicator";

const Game = () => {
  const { id } = useParams();
  const { user } = useContext(UserContext);
  const [game, loading] = useGameQuery(id);

  function handelCloseClick() {}

  if (loading) {
    return <LoadingIndicator />;
  }

  //is the user in this game
  if (game) {
    const playerIndex = game.players.findIndex(p => p.id === user.id);

    // console.log("PLAYER IN GAME")

    if (playerIndex < 0 || playerIndex > 3) {
      return (
        <>
          <Modal
            title="Can't Join Game..."
            hideClose
            isOpen={true}
            closeModal={() => handelCloseClick()}
          >
            <div className="join-game-modal">
              <div
                className="image-bar"
                style={{
                  backgroundImage: `url(${joinGameGIF})`
                }}
              ></div>
              <div className="copy text-center mx-auto">
                Looks like we cant get you into this game --
              </div>
              <div className="buttons flex items-center justify-center flex-col">
                <Link to="/">
                  <Button color="blue">Create or Join One</Button>
                </Link>
              </div>
            </div>
          </Modal>
        </>
      );
    }
  }

  return game ? (
    <PlayerContextProvider game={game} playerId={user.id}>
      <GameLobby game={game} />
    </PlayerContextProvider>
  ) : (
    <div>error!</div>
  );
};
export default Game;
